import { render, staticRenderFns } from "./公示公告.vue?vue&type=template&id=795c73b5&scoped=true"
import script from "./公示公告.vue?vue&type=script&lang=js"
export * from "./公示公告.vue?vue&type=script&lang=js"
import style0 from "./公示公告.vue?vue&type=style&index=0&id=795c73b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795c73b5",
  null
  
)

export default component.exports